
import { useEffect, useState } from "react";
import Preview from "../preview"


//not found
//hero-slider-01 
//video-tutorials-02
//latest-blog-03


// home data type completed

// index - 0 >> home_introduction >> validated
// index - 1 >> home_introduction_two >> validated
// index - 2 >> home_photo_gallery >> validated
// index - 3 >> home_introduction >> validated
// index - 4 >> home_photo_gallery >> validated
// index - 5 >> home_introduction_two >> validated
// index - 6 >> home_quote_one  >> validated
// index - 7>> home_introduction_three >> validated
// index - 8 >> home_introduction >> validated
// index - 9 >> home_text_gallery >> validated
// index - 10 >> home_photo_gallery >> validated
// index - 11 >> home_introduction_two >> validated
// index - 12 >> home_introduction_two >> validated
// index - 13 >> home_photo_gallery >> validated

// index - 14 >> home_photo_gallery discussion needed with mahima

// index - 15 >> home_introduction >> validated
// index - 16 >> home_introduction_three >> validated

// index - 17 >> home_photo_gallery discussion needed with mahima

// index - 18 >> home_photo_gallery >> validated
// index - 19 >> wave >> ajaya (pending)
// index - 20>> home_text_gallery_two   >> validated
// index - 21>> home_photo_gallery  >> validated
// index - 22>> home_photo_gallery  >> validated
// index - 23>> home_text_gallery_two >> validated
// index - 24>> home_text_gallery_two >> validated
// index - 25 >> home_introduction_two >> validated
// index - 26 >> home_introduction_three  >> validated
// index - 27 >> home_product_gallery >> validated
// index - 28 >> home_photo_gallery >> validated
// index - 29 >> home_photo_gallery_two >> validated
// index - 30 >> home_photo_gallery >> validated
// index - 31 >> about us working hours view  >> validated
// index - 32 >> home_text_gallery_two
// index - 33 >> home_photo_gallery >> validated
// index - 34 >> home_text_gallery_two >> validated
// index - 35 >> home_introduction_two >> validated
// index - 36 >> home_text_gallery_two >> validated
// index - 37 >> home_introduction_four >> validated
// index - 38 >> home_introduction >> validated



const connected = {
    "hero-slider-01":"65687903e5589670ba4e3b73",//home_introduction
    "video-tutorials-02":"654e3e1cb18f2578b61c3dc4", //home_introduction_two
   
    "hero-slider-04":"65687903e5589670ba4e3b73",//home_introduction
    "portfolio-05":"654e3dc133cf1040fe0b4a7f",//home_photo_gallery
    "hero-slider-03":"654e3e1cb18f2578b61c3dc4",//home_introduction_two
    "season-sale":"654e3d294fdc8307940bc74c",//home_quote_one
    "about-collection":"654e3d76447b5f399717e30f",//home_introduction_three
    "hero-slider-fitness":"65687903e5589670ba4e3b73",//home_introduction
    "why-fitness":"65705c8f93ae57781f4b515f",//home_text_gallery
    
    "fitness-team":"654e3dc133cf1040fe0b4a7f",//home_photo_gallery,
    "hero-slider-education":"654e3e1cb18f2578b61c3dc4", //home_introduction_two
    "education-team":"654e3dc133cf1040fe0b4a7f", //home_photo_gallery
    
    
    "master-gallery":"654e3dc133cf1040fe0b4a7f", //home_photo_gallery
    "hero-slider-store":"65abb88325350d4f9061d25e", //home_social_banner
    "store-app-screen":"654e3dc133cf1040fe0b4a7f",//home_photo_gallery,
    "store-products-list":"654e3dc133cf1040fe0b4a7f",//home_photo_gallery,
    "items-featured-wine":"654e3d4e6e37d976d7366e8c",//home_product_gallery 
    "img-list-wine":"654e3dc133cf1040fe0b4a7f",//home_photo_gallery
   "card-list-courses":"65bb9b2f1109527e3853616c",//home_card_list 
    "course-testimonial":"65bb9b2f1109527e3853616c",//home_card_list
    "hero-slider-restaurants":"65bb9b2f1109527e3853616c",//home_card_list
   

    //// NITIN Work below///
   // icon on img
    "store-feature-list":"65bb5f672c119f4d147ede18", //home_text_gallery_two - rework need to there is image in old one // 
    
    // discuss
    "hero-slider-wineshop":"65bb5f672c119f4d147ede18",  // home_text_gallery_two rrre work not loop
    "hero-slider-membership":"65bb5f672c119f4d147ede18",//home_text_gallery_two not match
    

    "contact-block-wine":"65bcd8957403e631d635af43",//home_business_hours Fixed
    "latest-blog-03":"65bb5f672c119f4d147ede18",//home_text_gallery_two - Fixed 
    "feature-list-course":"65bb5f672c119f4d147ede18",//34 home_text_gallery_two Fixed
    "feature-list-pricing":"65bb5f672c119f4d147ede18",//36 index //home_text_gallery_two Fixed 
    "education-features":"65b894faff49534e704e77cf", //home_features_list - Fixed
    "product-card-wine":"65bb9b2f1109527e3853616c",//home_card_list, Fixed
    "card-list-wine":"65bb9b2f1109527e3853616c",//home_card_list, Fixed
    "about-courses":"65abb88325350d4f9061d25e",//home_social_banner Fixed 
    "event-list":"65bbb03a535dae21186f5095", // home_event_list Fixed
    "about-wine":"65abb88325350d4f9061d25e", // home_social_banner Fixed 
    "product-list-wine":"65bb5f672c119f4d147ede18", // home_text_gallery_two Fixed
    "hero-slider-event":"65abb88325350d4f9061d25e", //home_social_banner Fixed 
    "download-app":"65abb88325350d4f9061d25e", //home_social_banner  - Fixed
    "about-event":"65abb88325350d4f9061d25e", //home_social_banner - Fixed
    "overlay-wine":"65abb88325350d4f9061d25e",//use home_social_banner if possible otherwise createe new Fixed
    
}


/*
home data type completed

index - 0 >> home_introduction >> validated
index - 1 >> home_introduction_two >> validated
index - 2 >> home_photo_gallery >> validated
index - 3 >> home_introduction >> validated
index - 4 >> home_photo_gallery >> validated
index - 5 >> home_introduction_two >> validated
index - 6 >> home_quote_one  >> validated
index - 7>> home_introduction_three >> validated
index - 8 >> home_introduction >> validated
index - 9 >> home_text_gallery >> validated
index - 10 >> home_photo_gallery >> validated
index - 11 >> home_introduction_two >> validated
index - 12 >> home_introduction_two >> validated
index - 13 >> home_photo_gallery >> validated

index - 14 >> home_photo_gallery discussion needed with mahima

index - 15 >> home_introduction >> validated
index - 16 >> home_introduction_three >> validated

index - 17 >> home_photo_gallery discussion needed with mahima

index - 18 >> home_photo_gallery >> validated
index - 19 >> wave >> ajaya (pending)
index - 20>> home_text_gallery_two   >> validated
index - 21>> home_photo_gallery  >> validated
index - 22>> home_photo_gallery  >> validated
index - 23>> home_text_gallery_two >> validated
index - 24>> home_text_gallery_two >> validated
index - 25 >> home_introduction_two >> validated
index - 26 >> home_introduction_three  >> validated
index - 27 >> home_product_gallery >> validated
index - 28 >> home_photo_gallery >> validated
index - 29 >> home_photo_gallery_two >> validated
index - 30 >> home_photo_gallery >> validated
index - 31 >> about us working hours view  >> validated
index - 32 >> home_text_gallery_two
index - 33 >> home_photo_gallery >> validated
index - 34 >> home_text_gallery_two >> validated
index - 35 >> home_introduction_two >> validated
index - 36 >> home_text_gallery_two >> validated
index - 37 >> home_introduction_four >> validated
index - 38 >> home_introduction >> validated 

*/

const fetchAi = async function(data) {
    const response = await fetch("https://snappy.appypie.com/webservices/aiEditorService.php", {
        method:"POST",
        body:JSON.stringify(data)
    })
    return await response.json();
}

const fetchJson = async function(data) {
    const response = await fetch("https://snappy.appypie.com/webservices/HomePage.php", {
        method:"POST",
        body:JSON.stringify(data)
    })
    //const response = await fetch("/homeLast9.json")
    return await response.json();
}

const fetchJson2 = async function(appId) {
    const response = await fetch("https://api.appexecutable.com/webservices/manifest-pwa.php", {
        method:"POST",
        body:JSON.stringify({ method: "getApp", appId, prevVersion: "0" })
    })
    //const response = await fetch("/homeLast9.json");

    const nextResponse =  await response.json();

    return nextResponse.homeData.publicJson;
}


const migrationProperties = function(type, properties, settings, pSettings, tm) {
   
    let keys = ["backgroundColor", "textAlign"];
    if(type === "root") {

    }
    if(type === "button") {
        const link = settings.link;
        if(link) {
            if(link.indexOf("/pages--") !== -1) {
                properties.link = `javascript:opendeeplinkpage('${link.replace("/pages--", "")}')`;
            }
            if(link.indexOf("https:") !== -1) {
                properties.link = link;
            }
            if(link.indexOf("http:") !== -1) {
                properties.link = link;
            }
            if(link.indexOf("mailto:") !== -1) {
                properties.link = link;
            }
            if(link.indexOf("tel:") !== -1) {
                properties.link = link;
            }
        }
        console.log(properties, settings);
        return properties;
    }
    if(type === "item") {
        //console.log(properties, settings);
        keys = ["backgroundColor", "color", "ratio", "size", "textAlign", "visible"];
    }
    keys.forEach(function(v){
        if(v === "visible") {
            if(settings[v] === false) {
                properties["show"] = false;
                properties["showWeb"] = false;
            }
        }
        else {
            if(v === "textAlign") {
               
                
                if(settings[v] === "") {
                    if(pSettings) {
                        if(tm) {
                            //console.log(tm, pSettings, properties["itemAlignment"])
                        }
                        let textAlign = "";
                        if(pSettings[v] === "text-center") {
                            textAlign = "center";
                        }
                        if(textAlign !== "") {
                            
                            if(properties["itemAlignment"]) {
                                properties["itemAlignment"] = textAlign;
                            }
                            if(properties["iconAlignment"]) {
                                properties["iconAlignment"] = textAlign;
                            }
                            if(properties["textAlignment"]) {
                                properties["textAlignment"] = textAlign;
                            }
                        }
                    }
                }
                else {
                    let textAlign = "justify";
                    if(settings[v] === "text-center") {
                        textAlign = "center";
                    }
                    else if(settings[v] === "text-start") {
                        textAlign = "start";
                    }
                    else if(settings[v] === "text-end") {
                        textAlign = "end";
                    }
                    if(properties["itemAlignment"]) {
                        properties["itemAlignment"] = textAlign;
                    }
                    if(properties["textAlignment"]) {
                        properties["textAlignment"] = textAlign;
                    }
                }
                

                
                
            }
            else {
                if(settings[v]) {
                    if(settings[v] !== "") {
                        if(v === "backgroundColor") {
                            if(settings[v].indexOf("https") !== -1) {
                                properties["background"] = settings[v];
                                properties["backgroundType"] = "image";
                            }
                            if(settings[v].indexOf("__CDN__PATH__") !== -1) {
                                properties["background"] = settings[v].replace("__CDN__PATH__", "https://d2wuvg8krwnvon.cloudfront.net/")
                                properties["backgroundType"] = "image";
                            }
                            if(settings[v].indexOf("#") !== -1) {
                                properties["background"] = settings[v];
                                properties["backgroundType"] = "color";
                            }
                            if(settings[v].indexOf("linear-gradient(") !== -1) {
                                const colors = settings[v].split(",");
                                const endColor = colors.pop().replace(")", "").trim();
                                const satrtColor = colors.pop().replace(")", "").trim()
                                properties["background"] = `${satrtColor}$$${endColor}`;
                                properties["backgroundType"] = "l_gradient";
                            }
                        }
                        if(v === "color") {
                            let setColor = settings[v];
                            if(settings[v] === "#fff") {
                                setColor = "#ffffff"
                            }
                            if(settings[v] === "#000") {
                                setColor = "#000000"
                            }
                            if(properties["textColor"]) {
                                properties["textColor"] = setColor;
                            }
                            if(properties["iconColor"]) {
                                properties["iconColor"] = settings[v];
                            }
                        }
                        if(v === "ratio") {
                            if(properties["ratio"]) {
                                properties["ratio"] = settings[v];
                                properties["ratioWeb"] = settings[v];
                            }
                        }
                        if(v === "size") {
                            if(properties["scaleType"]) {
                                properties["scaleType"] = settings[v];
                            }
                        }
                        
                    }
                    else {
                        if(v === "color") {
                            if(properties["color"]) {
                                properties["color"] = pSettings[v];
                            }
                        }
                    }
                }
            }
            
        }
        
        
    })
    
    return properties;
}

const migrationBlock = function(blockItem, oldBlock) {
    const id = blockItem.id;
    const block = JSON.parse(blockItem.data);
    
    if(id === "65687903e5589670ba4e3b73" && oldBlock.id === "hero-slider-01") {
        block.elements.swiper.items[0].heading.text = oldBlock.data.elements[0].text;
        block.elements.swiper.items[0].summary.text      = oldBlock.data.elements[1].text;
        block.elements.swiper.items[0].primaryButton.text      = oldBlock.data.elements[2].text;

        ["secondaryButton"].forEach(function(v){
            block.elements.swiper.items[0][v].properties.show = false;
            block.elements.swiper.items[0][v].properties.showWeb = false;
        });

        block.elements.swiper.items[0].primaryButton.properties = migrationProperties("button", block.elements.swiper.items[0].primaryButton.properties, oldBlock.data.elements[2]);

        
        block.properties = migrationProperties("root", block.properties, oldBlock.data.settings);

        ["heading", "summary", "primaryButton"].forEach(function(v, i){
            block.elements.swiper.items[0][v].properties.show = true;
            block.elements.swiper.items[0][v].properties.showWeb = true;
            block.elements.swiper.items[0][v].properties = migrationProperties("item", block.elements.swiper.items[0][v].properties, oldBlock.data.elements[i].settings, oldBlock.data.settings)
        });
    }
    if(id === "654e3e1cb18f2578b61c3dc4" && oldBlock.id === "video-tutorials-02") {
        block.elements.swiper.items[0].banner.properties.src = oldBlock.data.elements[0].src;
        block.elements.swiper.items[0].heading.text = oldBlock.data.elements[1].text;
        block.elements.swiper.items[0].headingLabel.text = oldBlock.data.elements[2].text;
        block.elements.swiper.items[0].summary.text = oldBlock.data.elements[3].text;
        block.elements.swiper.items[0].primaryButton.text = oldBlock.data.elements[4].text;
        
        block.elements.swiper.items[0].secondaryButton.properties.show = false;
        block.elements.swiper.items[0].secondaryButton.properties.showWeb = false;

        block.elements.swiper.items[0].primaryButton.properties = migrationProperties("button", block.elements.swiper.items[0].primaryButton.properties, oldBlock.data.elements[4]);

        block.properties = migrationProperties("root", block.properties, oldBlock.data.settings);

        ["banner", "heading", "headingLabel", "summary", "primaryButton"].forEach(function(v, i){
            block.elements.swiper.items[0][v].show = true;
            block.elements.swiper.items[0][v].showWeb = true;
            block.elements.swiper.items[0][v].properties = migrationProperties("item", block.elements.swiper.items[0][v].properties, oldBlock.data.elements[i].settings, oldBlock.data.settings)
        })
        // console.log(block);
        // console.log(oldBlock);

        
        
    }

    if(id === "65bb5f672c119f4d147ede18" && oldBlock.id === "latest-blog-03") {
        block.elements.heading.text = oldBlock.data.elements[0].text;
        
        ["primaryButton", "secondaryButton", "summary", "description"].forEach(function(v){
            block.elements[v].properties.show = false;
            block.elements[v].properties.showWeb = false;
        });

        block.properties = migrationProperties("root", block.properties, oldBlock.data.settings);
        block.elements.heading.properties = migrationProperties("item", block.elements.heading.properties, oldBlock.data.elements[0].settings, oldBlock.data.settings);

        const fresh = JSON.parse(JSON.stringify(block.elements.gallery.items[0]));

        block.elements.gallery.items = [];
        oldBlock.data.data.forEach(function(v, i){
            const item = JSON.parse(JSON.stringify(fresh));

            item.banner.properties.src = v.data[0].src;
            item.headingLabel.text = v.data[1].text;
            item.heading.text = v.data[2].text;
            item.summary.text = v.data[3].text;
            item.userBanner.properties.src = v.data[4].src;
            item.userDescription.text = v.data[5].text;

            item.properties.background = "#FFFFFF";
            item.properties.backgroundType = "color";

            item.properties = migrationProperties("item", item.properties, v.settings, oldBlock.data.settings);

            ["description", "subDescription", "socialInfo", "primaryButton"].forEach(function(v, i){
                item[v].properties.show = false;
                item[v].properties.showWeb = false;
            });

            ["banner", "headingLabel", "heading", "summary", "userBanner", "userDescription"].forEach(function(key, i){
                item[key].properties.show = true;
                item[key].properties.showWeb = true;
                item[key].properties = migrationProperties("item", item[key].properties, v.data[i].settings, oldBlock.data.settings);
            });

            block.elements.gallery.items.push(item);
        })


        
        // console.log(block);
        // console.log(oldBlock);
        
    }

    if(id === "65687903e5589670ba4e3b73" && oldBlock.id === "hero-slider-04") {
        
        block.elements.swiper.items[0].heading.text = oldBlock.data.elements[0].text;
        block.elements.swiper.items[0].summary.text      = oldBlock.data.elements[1].text;
        block.elements.swiper.items[0].primaryButton.text      = oldBlock.data.elements[2].text;
        block.elements.swiper.items[0].secondaryButton.text      = oldBlock.data.elements[3].text;

        block.properties = migrationProperties("root", block.properties, oldBlock.data.settings);

        block.elements.swiper.items[0].primaryButton.properties = migrationProperties("button", block.elements.swiper.items[0]["primaryButton"].properties, oldBlock.data.elements[2]);
        block.elements.swiper.items[0].secondaryButton.properties = migrationProperties("button", block.elements.swiper.items[0]["secondaryButton"].properties, oldBlock.data.elements[3]);

        ["heading", "summary", "primaryButton", "secondaryButton"].forEach(function(v, i){
            block.elements.swiper.items[0][v].properties.show = true;
            block.elements.swiper.items[0][v].properties.showWeb = true;
            block.elements.swiper.items[0][v].properties = migrationProperties("item", block.elements.swiper.items[0][v].properties, oldBlock.data.elements[i].settings, oldBlock.data.settings)
        });
    }

    if(id === "654e3dc133cf1040fe0b4a7f" && oldBlock.id === "portfolio-05") {
        
        block.elements.heading.text = oldBlock.data.elements[0].text;
        block.elements.summary.text = oldBlock.data.elements[1].text;

        ["primaryButton", "secondaryButton"].forEach(function(v){
            block.elements[v].properties.show = false;
            block.elements[v].properties.showWeb = false;
        });

        ["heading", "summary"].forEach(function(v, i){
            block.elements[v].properties = migrationProperties("item", block.elements[v].properties, oldBlock.data.elements[i].settings, oldBlock.data.settings);
        });

        block.properties = migrationProperties("root", block.properties, oldBlock.data.settings);

        const fresh = JSON.parse(JSON.stringify(block.elements.gallery.items[0]));
        ["banner", "bannerLabel", "description", "footerHeading", "heading", "icon", "socialInfo", "subDescription", "summary"].forEach(function(v){
            fresh[v].properties.show = false;
            fresh[v].properties.showWeb = false;
        });

        block.elements.gallery.items = [];
        oldBlock.data.data.forEach(function(v, i){
            const item = JSON.parse(JSON.stringify(fresh));

            item.heading.text = v.data[0].text;
            item.banner.properties.src = v.data[1].src;
            

            item.properties = migrationProperties("item", item.properties, v.settings, oldBlock.data.settings);

            ["heading", "banner"].forEach(function(val, i){
                item[val].properties.show = true;
                item[val].properties.showWeb = true;
                item[val].properties = migrationProperties("item", item[val].properties, v.data[i].settings, oldBlock.data.settings);
            });
            
            
            block.elements.gallery.items.push(item);
        })

        // console.log(block);
        // console.log(oldBlock);
    }

    if(id === "654e3e1cb18f2578b61c3dc4" && oldBlock.id === "hero-slider-03") {
        block.elements.footerSummary.text = oldBlock.data.elements[0].text;
        block.elements.footerSummary.properties.show = true;
        block.elements.footerSummary.properties.showWeb = true;

        ["footerSummary"].forEach(function(v, i){
            block.elements[v].properties = migrationProperties("item", block.elements[v].properties, oldBlock.data.elements[i].settings, oldBlock.data.settings);
        });

        block.properties = migrationProperties("root", block.properties, oldBlock.data.settings);

        const fresh = JSON.parse(JSON.stringify(block.elements.swiper.items[0]));
        ["headingLabel", "secondaryButton"].forEach(function(v){
            fresh[v].properties.show = false;
            fresh[v].properties.showWeb = false;
        });

        block.elements.swiper.items = [];

        oldBlock.data.data.forEach(function(v, i){
            const item = JSON.parse(JSON.stringify(fresh));

            item.heading.text = v.data[0].text;
            item.summary.text = v.data[1].text;
            item.primaryButton.text = v.data[2].text;
            item.banner.properties.src = v.data[3].src;

            item.properties = migrationProperties("item", item.properties, v.settings, oldBlock.data.settings);
            
            item.primaryButton.properties = migrationProperties("button", item.primaryButton.properties, v.data[2]);

            ["heading", "summary", "primaryButton", "banner"].forEach(function(val, i){
                item[val].properties = migrationProperties("item", item[val].properties, v.data[i].settings, oldBlock.data.settings);
            });

            block.elements.swiper.items.push(item);
        });
    }
    if(id === "654e3d294fdc8307940bc74c" && oldBlock.id === "season-sale") {
        block.properties = migrationProperties("root", block.properties, oldBlock.data.settings);

        const fresh = JSON.parse(JSON.stringify(block.elements.swiper.items[0]));
        ["primaryButton", "secondaryButton"].forEach(function(v){
            fresh[v].properties.show = false;
            fresh[v].properties.showWeb = false;
        });

        block.elements.swiper.items = [];

        oldBlock.data.data.forEach(function(v, i){
            const item = JSON.parse(JSON.stringify(fresh));

            item.headingLabel.text = v.data[0].text;
            item.heading.text = "50% Off";
            if(v.data[1].text) {
                if(v.data[1].text !== "") {
                    item.heading.text = v.data[1].text;
                }
            }
            
            item.summary.text = v.data[2].text;
            item.banner.properties.src = v.data[3].src;

            

            item.properties = migrationProperties("item", item.properties, v.settings, oldBlock.data.settings);

            item.heading.properties.padding = "0,0,0,0";
            item.heading.properties.paddingWeb = "0,0,0,0";

            ["headingLabel", "heading", "summary", "banner"].forEach(function(val, i){
                item[val].properties.show = true;
                item[val].properties.showWeb = true;
                item[val].properties = migrationProperties("item", item[val].properties, v.data[i].settings, oldBlock.data.settings);
                
            });
            block.elements.swiper.items.push(item);
        });
    }

    if(id === "654e3d76447b5f399717e30f" && oldBlock.id === "about-collection") {
        block.elements.heading.text = oldBlock.data.elements[0].text;
        block.elements.summary.text = oldBlock.data.elements[1].text;
       
         block.properties = migrationProperties("root", block.properties, oldBlock.data.settings);

        const fresh = JSON.parse(JSON.stringify(block.elements.swiper.items[0]));
       

        block.elements.swiper.items = [];

        oldBlock.data.data.forEach(function(v, i){
            const item = JSON.parse(JSON.stringify(fresh));

            item.footerHeading.text = v.data[0].text;
            item.footerSummary.text = v.data[1].text;
            
            item.properties = migrationProperties("item", item.properties, v.settings, oldBlock.data.settings);

            ["footerHeading", "footerSummary"].forEach(function(val, i){
                item[val].properties = migrationProperties("item", item[val].properties, v.data[i].settings, oldBlock.data.settings);
            });

            block.elements.swiper.items.push(item);
        });
    }

    if(id === "65687903e5589670ba4e3b73" && oldBlock.id === "hero-slider-fitness") {
        block.elements.swiper.items[0].heading.text = oldBlock.data.elements[0].text;
        block.elements.swiper.items[0].summary.text      = oldBlock.data.elements[1].text;
        ["primaryButton", "secondaryButton"].forEach(function(val, i){
            block.elements.swiper.items[0][val].properties.show      = false;
            block.elements.swiper.items[0][val].properties.showWeb      = false;
        });
        

        block.properties = migrationProperties("root", block.properties, oldBlock.data.settings);

        ["heading", "summary"].forEach(function(v, i){
            block.elements.swiper.items[0][v].properties = migrationProperties("item", block.elements.swiper.items[0][v].properties, oldBlock.data.elements[i].settings, oldBlock.data.settings)
        })

        // console.log(block);
        // console.log(oldBlock);
    }
    if(id === "65705c8f93ae57781f4b515f" && oldBlock.id === "why-fitness") {
        ["description", "heading", "primaryButton", "secondaryButton", "summary"].forEach(function(v){
            block.elements[v].properties.show = false;
            block.elements[v].properties.showWeb = false;
        })

         block.properties = migrationProperties("root", block.properties, oldBlock.data.settings);

         const fresh = JSON.parse(JSON.stringify(block.elements.gallery.items[0]));
         block.elements.gallery.items = [];
 
         oldBlock.data.data.forEach(function(v, i){
             const item = JSON.parse(JSON.stringify(fresh));
 
             item.icon.properties.iconCode = v.data[0].src;
             item.heading.text = v.data[1].text;
             item.summary.text = v.data[2].text;
             
             item.properties = migrationProperties("item", item.properties, v.settings, oldBlock.data.settings);

             ["icon", "heading", "summary"].forEach(function(val, i){
                 item[val].properties = migrationProperties("item", item[val].properties, v.data[i].settings, oldBlock.data.settings);
             });

             block.elements.gallery.items.push(item);
         })

        // console.log(block);
        // console.log(oldBlock);
    }

    if(id === "654e3dc133cf1040fe0b4a7f" && oldBlock.id === "fitness-team") {
        
        block.elements.heading.text = oldBlock.data.elements[0].text;
        block.elements.summary.text = oldBlock.data.elements[1].text;

        ["primaryButton", "secondaryButton"].forEach(function(v){
            block.elements[v].properties.show = false;
            block.elements[v].properties.showWeb = false;
        });

        ["heading", "summary"].forEach(function(v, i){
            block.elements[v].properties = migrationProperties("item", block.elements[v].properties, oldBlock.data.elements[i].settings, oldBlock.data.settings);
        });

         block.properties = migrationProperties("root", block.properties, oldBlock.data.settings);

        const fresh = JSON.parse(JSON.stringify(block.elements.gallery.items[0]));
        ["bannerLabel", "heading", "footerHeading",  "icon", "socialInfo", "subDescription"].forEach(function(v){
            fresh[v].properties.show = false;
            fresh[v].properties.showWeb = false;
        })

        block.elements.gallery.items = [];
        block.elements.gallery.properties.spanWeb = 4;
        oldBlock.data.data.forEach(function(v, i){
            const item = JSON.parse(JSON.stringify(fresh));

            item.banner.properties.src = v.data[0].src;
            item.summary.text = v.data[1].text;
            item.description.text = v.data[2].text;

            item.properties = migrationProperties("item", item.properties, v.settings, oldBlock.data.settings);

            ["banner", "summary", "description"].forEach(function(val, i){
                item[val].properties.show = true;
                item[val].properties.showWeb = true;
                item[val].properties = migrationProperties("item", item[val].properties, v.data[i].settings, oldBlock.data.settings);
            })
            block.elements.gallery.items.push(item);
        })

        // console.log(block);
        // console.log(oldBlock);
    }

    if(id === "65abb88325350d4f9061d25e" && oldBlock.id === "download-app") {

        ["heading", "summary", "description"].forEach(function(v){
            block.elements[v].properties.show = false;
            block.elements[v].properties.showWeb = false;
        });

        block.properties = migrationProperties("root", block.properties, oldBlock.data.settings);

        const fresh = JSON.parse(JSON.stringify(block.elements.swiper.items[0]));
        
        fresh.heading.text = oldBlock.data.elements[0].text;
        fresh.summary.text = oldBlock.data.elements[1].text;
        fresh.googleplay.text = oldBlock.data.elements[2].src.replace("__CDN__PATH__", "https://d2wuvg8krwnvon.cloudfront.net/");
        fresh.appstore.properties.src = oldBlock.data.elements[3].src.replace("__CDN__PATH__", "https://d2wuvg8krwnvon.cloudfront.net/");
        fresh.banner.properties.src = oldBlock.data.elements[4].src;

        ["heading", "summary", "googleplay", "appstore", "banner"].forEach(function(v, i){
            fresh[v].properties.show = true;
            fresh[v].properties.showWeb = true;
            fresh[v].properties = migrationProperties("item", fresh[v].properties, oldBlock.data.elements[i].settings, oldBlock.data.settings);
        });
        

        ["secondaryButton", "headingLabel", "primaryButton"].forEach(function(v){
            fresh[v].properties.show = false;
            fresh[v].properties.showWeb = false;
        });


        block.elements.swiper.properties.span = 1;
        block.elements.swiper.properties.spanWeb = 1;
        block.elements.swiper.items = [fresh];
        
        // console.log(block);
        // console.log(oldBlock);
        
    }

    if(id === "654e3e1cb18f2578b61c3dc4" && oldBlock.id === "hero-slider-education") {
        block.elements.swiper.items[0].heading.text = oldBlock.data.elements[0].text;
        block.elements.swiper.items[0].summary.text = oldBlock.data.elements[1].text;
        block.elements.swiper.items[0].primaryButton.text = oldBlock.data.elements[2].text;
        block.elements.swiper.items[0].secondaryButton.text = oldBlock.data.elements[3].text;
        block.elements.swiper.items[0].banner.properties.src = oldBlock.data.elements[4].src;
       


        block.elements.swiper.items[0].headingLabel.properties.show = false;

        // block.properties = migrationProperties("root", block.properties, oldBlock.data.settings);

        ["heading", "summary", "primaryButton", "secondaryButton", "banner"].forEach(function(v, i){
            block.elements.swiper.items[0][v].properties = migrationProperties("item", block.elements.swiper.items[0][v].properties, oldBlock.data.elements[i].settings, oldBlock.data.settings)
        })
        // console.log(block);
        // console.log(oldBlock);
        
    }

    if(id === "654e3dc133cf1040fe0b4a7f" && oldBlock.id === "education-team") {

        block.elements.heading.text = oldBlock.data.elements[0].text;
        block.elements.summary.text = oldBlock.data.elements[1].text;
        block.elements.primaryButton.text = oldBlock.data.elements[2].text;
        block.elements.secondaryButton.properties.show = false;
        block.elements.secondaryButton.properties.showWeb = false;

        block.elements.primaryButton.properties = migrationProperties("button", block.elements.primaryButton.properties, oldBlock.data.elements[2]);


        ["heading", "summary", "primaryButton"].forEach(function(v, i){
            block.elements[v].properties = migrationProperties("item", block.elements[v].properties, oldBlock.data.elements[i].settings, oldBlock.data.settings);
        });


        

        block.properties = migrationProperties("root", block.properties, oldBlock.data.settings);

        const fresh = JSON.parse(JSON.stringify(block.elements.gallery.items[0]));
        ["bannerLabel", "heading", "footerHeading",  "icon", "socialInfo", "subDescription"].forEach(function(v){
            fresh[v].properties.show = false;
            fresh[v].properties.showWeb = false;
        })

        block.elements.gallery.items = [];
        oldBlock.data.data.forEach(function(v, i){
            const item = JSON.parse(JSON.stringify(fresh));

            item.banner.properties.src = v.data[0].src;
            item.summary.text = v.data[1].text;
            item.description.text = v.data[2].text;

            item.properties = migrationProperties("item", item.properties, v.settings, oldBlock.data.settings);

            ["banner", "summary", "description"].forEach(function(val, i){
                item[val].properties.show = true;
                item[val].properties.showWeb = true;
                item[val].properties = migrationProperties("item", item[val].properties, v.data[i].settings, oldBlock.data.settings);
            })
            block.elements.gallery.items.push(item);
        })

       
        // console.log(block);
        // console.log(oldBlock);
        
    }
    if(id === "65abb88325350d4f9061d25e" && oldBlock.id === "hero-slider-event") {
       

        ["heading", "summary", "description"].forEach(function(v){
            block.elements[v].properties.show = false;
            block.elements[v].properties.showWeb = false;
        });
        
       
        block.properties = migrationProperties("root", block.properties, oldBlock.data.settings);

        const fresh = JSON.parse(JSON.stringify(block.elements.swiper.items[0]));
        ["appstore", "googleplay", "headingLabel"].forEach(function(v){
            fresh[v].properties.show = false;
            fresh[v].properties.showWeb = false;
        })

        block.elements.swiper.items = [];
        oldBlock.data.data.forEach(function(v, i){
            const item = JSON.parse(JSON.stringify(fresh));

            item.heading.text = v.data[0].text;
            if(v.data[1].text === "") {
                item.summary.text = `The standard chunk of Lorem Ipsum used since the 1500s is reproduced below Food, in the end, in our own tradition, is something holy.`
            }
            else {
                item.summary.text = v.data[1].text;
            }
            
            item.primaryButton.text = v.data[2].text;
            item.secondaryButton.text = v.data[3].text;
            item.banner.properties.src = v.data[4].src;

            item.primaryButton.properties = migrationProperties("button", item.primaryButton.properties, v.data[2]);
            item.secondaryButton.properties = migrationProperties("button", item.secondaryButton.properties, v.data[3]);

            item.properties = migrationProperties("item", item.properties, v.settings, oldBlock.data.settings);

            
           

            ["heading", "summary", "primaryButton", "secondaryButton", "banner"].forEach(function(val, i){
                item[val].properties.show = true;
                item[val].properties.showWeb = true;
                item[val].properties = migrationProperties("item", item[val].properties, v.data[i].settings, oldBlock.data.settings);
            })
             block.elements.swiper.items.push(item);
        });

        // console.log(block);
        // console.log(oldBlock);
    }
    if(id === "65abb88325350d4f9061d25e" && oldBlock.id === "about-event") {
        block.elements.heading.text = oldBlock.data.elements[0].text;
        block.elements.summary.text = oldBlock.data.elements[1].text;
        block.elements.description.text = oldBlock.data.elements[2].text;

        ["heading", "summary", "description"].forEach(function(v, i){
            block.elements[v].properties.show = true;
            block.elements[v].properties.showWeb = true;
            block.elements[v].properties = migrationProperties("item", block.elements[v].properties, oldBlock.data.elements[i].settings, oldBlock.data.settings);

        });

       

       
        block.properties = migrationProperties("root", block.properties, oldBlock.data.settings);

        const fresh = JSON.parse(JSON.stringify(block.elements.swiper.items[0]));
        
       
        ["heading", "summary", "googleplay", "appstore", "banner", "secondaryButton", "headingLabel", "primaryButton"].forEach(function(v, i){
            fresh[v].properties.show = false;
            fresh[v].properties.showWeb = false;
        });


        block.elements.swiper.properties.span = 1;
        block.elements.swiper.properties.spanWeb = 1;
        block.elements.swiper.items = [fresh];


        // console.log(block);
        // console.log(oldBlock);

        
    }
    if(id === "65abb88325350d4f9061d25e" && oldBlock.id === "hero-slider-store") {
        // block.elements.heading.text = oldBlock.data.elements[0].text;
        // block.elements.summary.text = oldBlock.data.elements[1].text;
        // block.elements.description.text = oldBlock.data.elements[2].text;

        ["heading", "summary", "description"].forEach(function(v, i){
            block.elements[v].properties.show = false;
            block.elements[v].properties.showWeb = false;
        });

       
        block.properties.background = "https://d2wuvg8krwnvon.cloudfront.net/inlineeditor/media/bg-girl-01.jpeg";
        
        block.properties.backgroundType = "image";
        block.properties.overlayColor = "#88d24354";
       
        block.properties = migrationProperties("root", block.properties, oldBlock.data.settings);

        const fresh = JSON.parse(JSON.stringify(block.elements.swiper.items[0]));

        fresh.heading.text = oldBlock.data.elements[0].text;
        fresh.summary.text = oldBlock.data.elements[1].text;
        fresh.primaryButton.text = oldBlock.data.elements[2].text;
        fresh.secondaryButton.text = oldBlock.data.elements[3].text;
        fresh.banner.properties.src = oldBlock.data.elements[4].src;
        
       
        ["googleplay", "appstore",  "headingLabel"].forEach(function(v, i){
            fresh[v].properties.show = false;
            fresh[v].properties.showWeb = false;
        });

        ["heading", "summary", "primaryButton", "secondaryButton", "banner"].forEach(function(v, i){
            fresh[v].properties.show = true;
            fresh[v].properties.showWeb = true;
            fresh[v].properties = migrationProperties("item", fresh[v].properties, oldBlock.data.elements[i].settings, oldBlock.data.settings);

        });


        block.elements.swiper.properties.span = 1;
        block.elements.swiper.properties.spanWeb = 1;
        block.elements.swiper.items = [fresh];


        // console.log(block);
        // console.log(oldBlock);

        
    }

    
    if(id === "65bbb03a535dae21186f5095" && oldBlock.id === "event-list") {
        

        block.elements.heading.text = oldBlock.data.elements[0].text;
        block.elements.description.text = `A learners go-to platform for the latest innovations, discoveries, exam tips and more.`;
        if(oldBlock.data.elements[1].text) {
            if(oldBlock.data.elements[1].text !== "") {
                block.elements.description.text = oldBlock.data.elements[1].text;
            }
        }
       
        ["heading", "description"].forEach(function(v, i){
            block.elements[v].properties.show = true;
            block.elements[v].properties.showWeb = true;
            block.elements[v].properties = migrationProperties("item", block.elements[v].properties, oldBlock.data.elements[i].settings, oldBlock.data.settings);
        });

        ["primaryButton", "secondaryButton", "summary"].forEach(function(v){
            block.elements[v].properties.show = false;
            block.elements[v].properties.showWeb = false;
        });

        block.properties = migrationProperties("root", block.properties, oldBlock.data.settings);

        const fresh = JSON.parse(JSON.stringify(block.elements.gallery.items[0]));
        ["socialInfo", "primaryButton", "secondaryButton"].forEach(function(v){
            fresh[v].properties.show = false;
            fresh[v].properties.showWeb = false;
        });

        block.elements.gallery.items = [];
        block.elements.gallery.properties.span = 1;
        block.elements.gallery.properties.spanWeb = 4;
        oldBlock.data.data.forEach(function(v, i){
            const item = JSON.parse(JSON.stringify(fresh));

            item.banner.properties.src = v.data[0].src;
            
            item.headingLabel.text = v.data[1].text;
             item.heading.text = v.data[2].text;
            item.summary.text = v.data[3].text;
            item.description.text = v.data[4].text;
            item.subDescription.text = v.data[5].text;

            item.properties = migrationProperties("item", item.properties, v.settings, oldBlock.data.settings);

            ["banner", "headingLabel", "heading", "summary", "description", "subDescription"].forEach(function(val, i){
                item[val].properties.show = true;
                item[val].properties.showWeb = true;
                item[val].properties = migrationProperties("item", item[val].properties, v.data[i].settings, oldBlock.data.settings);
            });
            
            block.elements.gallery.items.push(item);
        })
        
        // console.log(block);
        // console.log(oldBlock);
        
    }

    if(id === "654e3dc133cf1040fe0b4a7f" && oldBlock.id === "master-gallery") {
        
        block.elements.heading.text = oldBlock.data.elements[0].text;
        block.elements.summary.text = oldBlock.data.elements[1].text;
        ["primaryButton", "secondaryButton"].forEach(function(v, i){
            block.elements[v].properties.show = false;
            block.elements[v].properties.showWeb = false;
        });
        
        ["heading", "summary"].forEach(function(v, i){
            block.elements[v].properties.show = true;
            block.elements[v].properties.showWeb = true;
            block.elements[v].properties = migrationProperties("item", block.elements[v].properties, oldBlock.data.elements[i].settings, oldBlock.data.settings);
        });

        block.properties = migrationProperties("root", block.properties, oldBlock.data.settings);
        const fresh = JSON.parse(JSON.stringify(block.elements.gallery.items[0]));

        ["bannerLabel", "heading" ,"description", "footerHeading",  "icon", "socialInfo", "subDescription", "summary"].forEach(function(v){
            fresh[v].properties.show = false;
            fresh[v].properties.showWeb = false;
        });

        block.elements.gallery.items = [];
        block.elements.gallery.properties.spanWeb = 4;
        block.elements.gallery.properties.span = 1;
        oldBlock.data.data.forEach(function(v, i){
            const item = JSON.parse(JSON.stringify(fresh));
            item.banner.properties.src = v.data[1].src;

            item.properties = migrationProperties("item", item.properties, v.settings, oldBlock.data.settings);

            ["banner"].forEach(function(val, i){
                item[val].properties.show = true;
                item[val].properties.showWeb = true;
                item[val].properties = migrationProperties("item", item[val].properties, v.data[1].settings, oldBlock.data.settings);
            })
            block.elements.gallery.items.push(item);
        })
        
        // console.log(block);
        // console.log(oldBlock);
        
    }
    if(id === "65bb5f672c119f4d147ede18" && oldBlock.id === "store-feature-list") {
        block.elements.heading.text = oldBlock.data.elements[0].text;
       
        ["primaryButton", "secondaryButton", "summary", "description"].forEach(function(v){
            block.elements[v].properties.show = false;
            block.elements[v].properties.showWeb = false;
        });
        
        ["heading"].forEach(function(v, i){
            block.elements[v].properties.show = true;
            block.elements[v].properties.showWeb = true;
            block.elements[v].properties = migrationProperties("item", block.elements[v].properties, oldBlock.data.elements[i].settings, oldBlock.data.settings);
        });


        block.properties = migrationProperties("root", block.properties, oldBlock.data.settings);
        
        const fresh = JSON.parse(JSON.stringify(block.elements.gallery.items[0]));

        ["description" , "headingLabel",  "icon", "primaryButton", "socialInfo", "subDescription", "summary", "userBanner", "userDescription"].forEach(function(v){
            fresh[v].properties.show = false;
            fresh[v].properties.showWeb = false;
        })

        block.elements.gallery.items = [];
        oldBlock.data.data.forEach(function(v, i){
            const item = JSON.parse(JSON.stringify(fresh));
            item.banner.properties.src = v.data[0].src.replace("__CDN__PATH__", "https://d2wuvg8krwnvon.cloudfront.net/");;
            item.icon.properties.iconCode = v.data[1].src;
            item.heading.text = v.data[2].text;
            item.summary.text = v.data[3].text;

            item.properties = migrationProperties("item", item.properties, v.settings, oldBlock.data.settings);
            item.properties.background = "#00000000";
            
         
            ["banner", "icon", "heading", "summary"].forEach(function(val, i){
                item[val].properties.show = true;
                item[val].properties.showWeb = true;
                item[val].properties = migrationProperties("item", item[val].properties, v.data[i].settings, oldBlock.data.settings);
            });
           

            block.elements.gallery.items.push(item);
        })
        
        // console.log(block);
        // console.log(oldBlock);
        
    }
    if(id === "654e3dc133cf1040fe0b4a7f" && oldBlock.id === "store-app-screen") {
        
        block.elements.heading.text = oldBlock.data.elements[0].text;
        block.elements.summary.text = "Convenient and hassle-free way to exchange goods over the internet";
        if(oldBlock.data.elements[1].text) {
            if(oldBlock.data.elements[1].text !== "") {
                block.elements.summary.text = oldBlock.data.elements[1].text;
            }
        }

        

        ["primaryButton", "secondaryButton"].forEach(function(v){
            block.elements[v].properties.show = false;
            block.elements[v].properties.showWeb = false;
        });
        
        ["heading", "summary"].forEach(function(v, i){
            block.elements[v].properties = migrationProperties("item", block.elements[v].properties, oldBlock.data.elements[i].settings, oldBlock.data.settings);
        });

        block.properties = migrationProperties("root", block.properties, oldBlock.data.settings);
        const fresh = JSON.parse(JSON.stringify(block.elements.gallery.items[0]));


        ["bannerLabel", "heading" ,"description", "footerHeading",  "icon", "socialInfo", "subDescription", "summary"].forEach(function(v){
            fresh[v].properties.show = false;
            fresh[v].properties.showWeb = false;
        })

        block.elements.gallery.items = [];
        block.elements.gallery.properties.spanWeb = oldBlock.data.settings.size;
        
        oldBlock.data.data.forEach(function(v, i){
            const item = JSON.parse(JSON.stringify(fresh));

            // item.bannerLabel.properties.show = false;

            item.banner.properties.src = v.data[1].src;
            item.properties = migrationProperties("item", item.properties, v.settings, oldBlock.data.settings);
            
            ["banner"].forEach(function(val, i){
                item[val].properties = migrationProperties("item", item[val].properties, v.data[1].settings, oldBlock.data.settings);
            })
            // item.heading.text = v.data[1].src;
            block.elements.gallery.items.push(item);

            
        })

        // console.log(block);
        // console.log(oldBlock);
    }
    if(id === "654e3dc133cf1040fe0b4a7f" && oldBlock.id === "store-products-list") {
        
        block.elements.heading.text = oldBlock.data.elements[0].text;
        block.elements.summary.text = "Convenient and hassle-free way to exchange goods over the internet";
        if(oldBlock.data.elements[1].text) {
            if(oldBlock.data.elements[1].text !== "") {
                block.elements.summary.text = oldBlock.data.elements[1].text;
            }
        }

        ["primaryButton", "secondaryButton"].forEach(function(v, i){
            block.elements[v].properties.show = false;
            block.elements[v].properties.showWeb = false;
        });

        ["heading", "summary"].forEach(function(v, i){
            block.elements[v].properties = migrationProperties("item", block.elements[v].properties, oldBlock.data.elements[i].settings, oldBlock.data.settings);
        });

        block.properties = migrationProperties("root", block.properties, oldBlock.data.settings);
        const fresh = JSON.parse(JSON.stringify(block.elements.gallery.items[0]));


        ["bannerLabel", "heading", "footerHeading", "socialInfo"].forEach(function(v){
            fresh[v].properties.show = false;
            fresh[v].properties.showWeb = false;
        })

        block.elements.gallery.items = [];
        block.elements.gallery.properties.spanWeb = oldBlock.data.settings.size;
        
        oldBlock.data.data.forEach(function(v, i){
            const item = JSON.parse(JSON.stringify(fresh));

            item.icon.properties.iconCode = v.data[0].src;
            item.banner.properties.src = v.data[1].src.replace("__CDN__PATH__", "https://d2wuvg8krwnvon.cloudfront.net/");
            item.summary.text = v.data[2].text;
            item.description.text = v.data[3].text;
            item.subDescription.text = v.data[4].text;

            
            ["icon", "banner", "summary", "description", "subDescription"].forEach(function(val, i){
                item[val].properties.show = true;
                item[val].properties.showWeb = true;
                item[val].properties = migrationProperties("item", item[val].properties, v.data[i].settings, oldBlock.data.settings);
            });
            block.elements.gallery.items.push(item);

            
        })

        // console.log(block);
        // console.log(oldBlock);
    }

    if(id === "65bb5f672c119f4d147ede18" && oldBlock.id === "hero-slider-wineshop") {  
        block.elements.heading.text = "TASTE OF GREAT FOOD";
        if(oldBlock.data.elements[0].text) {
            if(oldBlock.data.elements[0].text !== "") {
                block.elements.heading.text = oldBlock.data.elements[0].text;
            }
        }
        //block.elements.heading.text = "test me";
        block.elements.summary.text = oldBlock.data.elements[1].text;
        block.elements.description.text = oldBlock.data.elements[2].text;
        block.elements.primaryButton.text = oldBlock.data.elements[12].text;
        block.elements.secondaryButton.text = oldBlock.data.elements[13].text;

        block.elements.primaryButton.properties = migrationProperties("button", block.elements.primaryButton.properties, oldBlock.data.elements[12]);
        block.elements.secondaryButton.properties = migrationProperties("button", block.elements.secondaryButton.properties, oldBlock.data.elements[13]);

        const oldItems = [0, 1, 2, 12, 13];

        ["heading", "summary", "description", "primaryButton", "secondaryButton"].forEach(function(v, i){
            block.elements[v].properties.show = true;
            block.elements[v].properties.showWeb = true;
            block.elements[v].properties = migrationProperties("item", block.elements[v].properties, oldBlock.data.elements[oldItems[i]].settings, oldBlock.data.settings);
        });


        block.properties = migrationProperties("root", block.properties, oldBlock.data.settings);
        block.properties.overlayColor = "#66000000";
        const fresh = JSON.parse(JSON.stringify(block.elements.gallery.items[0]));

        ["icon", "banner", "headingLabel", "heading", "summary", "description", "subDescription", "socialInfo", "userBanner", "userDescription", "primaryButton"].forEach(function(v){
            fresh[v].properties.show = false;
            fresh[v].properties.showWeb = false;
        });

        block.elements.gallery.items = [];
        block.elements.gallery.properties.spanWeb = 3;
        block.elements.gallery.properties.span = 1;

        const tempArray = ["Write us", "Find us", "Call us"];

        [[3, 4, 5], [6, 7, 8], [9, 10, 11]].forEach(function(values, i){
            const item = JSON.parse(JSON.stringify(fresh));
            item["icon"].properties.iconCode = oldBlock.data.elements[values[0]].src;
            item["heading"].text = tempArray[i];
            if(oldBlock.data.elements[values[1]].text) {
                if(oldBlock.data.elements[values[1]].text !== "") {
                    item["heading"].text = oldBlock.data.elements[values[1]].text;
                }
            }
           
            item["summary"].text = oldBlock.data.elements[values[2]].text;

            item.properties.background = "#00000000";
            item.properties.backgroundType = "color";
            
            

            ["icon", "heading", "summary"].forEach(function(val, i){
                item[val].properties.show = true;
                item[val].properties.showWeb = true;
                item[val].properties = migrationProperties("item", item[val].properties, oldBlock.data.elements[values[i]].settings, oldBlock.data.settings, true);
            });
            block.elements.gallery.items.push(item);
        });

        //console.log(block);
        // console.log(oldBlock);
    }

    if(id === "65bb5f672c119f4d147ede18" && oldBlock.id === "product-list-wine") {
        block.elements.heading.text = oldBlock.data.elements[0].text;
        block.elements.summary.text = oldBlock.data.elements[1].text;
        
        ["primaryButton", "secondaryButton", "description"].forEach(function(v){
            block.elements[v].properties.show = false;
            block.elements[v].properties.showWeb = false;
        });

        block.properties = migrationProperties("root", block.properties, oldBlock.data.settings);
        ["heading", "summary"].forEach(function(v, i){
            block.elements[v].properties = migrationProperties("item", block.elements[v].properties, oldBlock.data.elements[i].settings, oldBlock.data.settings);
        });

        const fresh = JSON.parse(JSON.stringify(block.elements.gallery.items[0]));

        

        ["userBanner", "socialInfo", "banner", "summary"].forEach(function(v){
            fresh[v].properties.show = false;
            fresh[v].properties.showWeb = false;
        });

        block.elements.gallery.properties.span = 1;
        block.elements.gallery.properties.spanWeb = 4;

        block.elements.gallery.items = [];
        oldBlock.data.data.forEach(function(v, i){
            const item = JSON.parse(JSON.stringify(fresh));

           
            item.headingLabel.text = v.data[0].text;
            item.heading.text = v.data[1].text;
            item.description.text = v.data[2].text;
            item.subDescription.text = v.data[3].text;
            item.primaryButton.text = "Button Text";
            if(v.data[4].text) {
                if(v.data[4].text !== "") {
                    item.primaryButton.text = v.data[4].text;
                }
            }
            
            item.primaryButton.properties = migrationProperties("button", item.primaryButton.properties, v.data[4]);

            item.properties = migrationProperties("item", item.properties, v.settings, oldBlock.data.settings);
           

            ["headingLabel", "heading", "description", "subDescription", "primaryButton"].forEach(function(val, i){
                item[val].properties.show = true;
                item[val].properties.showWeb = true;
                item[val].properties = migrationProperties("item", item[val].properties, v.data[i].settings, oldBlock.data.settings);
            });
           

            block.elements.gallery.items.push(item);
        })

        // console.log(block);
        // console.log(oldBlock);
    }
    if(id === "65abb88325350d4f9061d25e" && oldBlock.id === "about-wine") {
        
        ["heading", "summary", "description"].forEach(function(v){
            block.elements[v].properties.show = false;
            block.elements[v].properties.showWeb = false;
        });
        
        block.properties = migrationProperties("root", block.properties, oldBlock.data.settings);
        const fresh = JSON.parse(JSON.stringify(block.elements.swiper.items[0]));

        fresh.headingLabel.text = "Some interesting information about us and our club";
        if(oldBlock.data.elements[0].text) {
            if(oldBlock.data.elements[0].text !== "") {
                fresh.headingLabel.text = oldBlock.data.elements[0].text;
            }
        }
      
        fresh.heading.text = oldBlock.data.elements[1].text;
        fresh.summary.text = `Tincidunt integer eu augue augue nunc elit dolor luctus placerat scelerisque euismod, iaculis eu lacus nunc mi elit, vehicula ut laoreet ac, aliquam sit amet justo nunc tempor metus vel. Tincidunt integer eu augue augue nunc elit dolor luctus placerat scelerisque euismod iaculis eu lacus nunc mi elit, vehicula ut laoreet ac, aliquam sit amet justo nunc tempor metus velo ipressum vastorio pelmone perende.`;
        if(oldBlock.data.elements[2].text) {
            if(oldBlock.data.elements[2].text !== "") {
                fresh.summary.text = oldBlock.data.elements[2].text;
            }
        }

        fresh.primaryButton.text = oldBlock.data.elements[3].text;
        fresh.googleplay.properties.src = oldBlock.data.elements[4].src.replace("__CDN__PATH__", "https://d2wuvg8krwnvon.cloudfront.net/");;
        fresh.banner.properties.src = oldBlock.data.elements[5].src;
        
        ["headingLabel", "heading", "summary", "primaryButton", "googleplay", "banner"].forEach(function(v, i){
            fresh[v].properties.show = true;
            fresh[v].properties.showWeb = true;
            fresh[v].properties = migrationProperties("item", fresh[v].properties, oldBlock.data.elements[i].settings, oldBlock.data.settings);
        });

        ["secondaryButton", "appstore"].forEach(function(v){
            fresh[v].properties.show = false;
            fresh[v].properties.showWeb = false;
        });

        block.elements.swiper.properties.span = 1;
        block.elements.swiper.properties.spanWeb = 1;
        block.elements.swiper.items = [fresh];

        // console.log(block);
        // console.log(oldBlock);
    }

    if(id === "65abb88325350d4f9061d25e" && oldBlock.id === "overlay-wine") {

        ["heading", "summary", "description"].forEach(function(v){
            block.elements[v].properties.show = false;
            block.elements[v].properties.showWeb = false;
        });
        
        block.properties = migrationProperties("root", block.properties, oldBlock.data.settings);
        const fresh = JSON.parse(JSON.stringify(block.elements.swiper.items[0]));
      
        fresh.headingLabel.text = oldBlock.data.elements[0].text;
        fresh.heading.text = oldBlock.data.elements[1].text;
        fresh.summary.text = oldBlock.data.elements[2].text;
        fresh.primaryButton.text = oldBlock.data.elements[3].text;
        fresh.banner.properties.src = oldBlock.data.elements[4].src;

        ["headingLabel", "heading", "summary", "primaryButton", "banner"].forEach(function(v, i){
            fresh[v].properties.show = true;
            fresh[v].properties.showWeb = true;
            fresh[v].properties = migrationProperties("item", fresh[v].properties, oldBlock.data.elements[i].settings, oldBlock.data.settings);
        });

        ["secondaryButton", "appstore", "googleplay"].forEach(function(v){
            fresh[v].properties.show = false;
            fresh[v].properties.showWeb = false;
        });

        block.elements.swiper.properties.span = 1;
        block.elements.swiper.properties.spanWeb = 1;
        block.elements.swiper.items = [fresh];

        // console.log(block);
        // console.log(oldBlock);
    }

    if(id === "654e3d4e6e37d976d7366e8c" && oldBlock.id === "items-featured-wine") {
        block.elements.heading.text = "Hand made ice creams";
        if(oldBlock.data.elements[0].text) {
            if(oldBlock.data.elements[0].text !== "") {
                block.elements.heading.text = oldBlock.data.elements[0].text;
            }
        }
        block.elements.summary.text = "ICE CREAMS"
        if(oldBlock.data.elements[0].text) {
            if(oldBlock.data.elements[0].text !== "") {
                block.elements.summary.text = oldBlock.data.elements[1].text;
            }
        }
        
        
        block.elements.banner.properties.src = oldBlock.data.elements[2].src;

        

        

        ["primaryButton", "secondaryButton"].forEach(function(v){
            block.elements[v].properties.show = false;
            block.elements[v].properties.showWeb = false;
        });
        

        ["heading", "summary", "banner"].forEach(function(v, i){
            block.elements[v].properties.show = true;
            block.elements[v].properties.showWeb = true;
            block.elements[v].properties = migrationProperties("item", block.elements[v].properties, oldBlock.data.elements[i].settings, oldBlock.data.settings);
        });

        block.properties = migrationProperties("root", block.properties, oldBlock.data.settings);
        
        const fresh = JSON.parse(JSON.stringify(block.elements.gallery.items[0]));

        // ["heading"].forEach(function(v){
        //     fresh[v].properties.show = false;
        // })

        block.elements.gallery.items = [];
        block.elements.gallery.properties.spanWeb = oldBlock.data.settings.size;
        
        oldBlock.data.data.forEach(function(v, i){
            const item = JSON.parse(JSON.stringify(fresh));
            
            item.banner.properties.src = v.data[0].src.replace("__CDN__PATH__", "https://d2wuvg8krwnvon.cloudfront.net/");
            item.heading.text = v.data[1].text;
            item.summary.text = v.data[2].text;
            item.description.text = v.data[3].text;

            ["banner", "heading", "summary", "description"].forEach(function(val, i){
                item[val].properties = migrationProperties("item", item[val].properties, v.data[1].settings, oldBlock.data.settings);
            })
            block.elements.gallery.items.push(item);

            
        })

        // console.log(block);
        // console.log(oldBlock);
    }
    if(id === "65bb9b2f1109527e3853616c" && oldBlock.id === "product-card-wine") {
        
        block.elements.heading.text = oldBlock.data.elements[0].text;
        block.elements.description.text = oldBlock.data.elements[1].text;

        ["heading", "description"].forEach(function(v, i){
            block.elements[v].properties.show = true;
            block.elements[v].properties.showWeb = true;
            block.elements[v].properties = migrationProperties("item", block.elements[v].properties, oldBlock.data.elements[i].settings, oldBlock.data.settings);
        });

        ["primaryButton", "secondaryButton", "summary"].forEach(function(v){
            block.elements[v].properties.show = false;
            block.elements[v].properties.showWeb = false;
        });

        block.properties.isFluid = "container-fluid";
        block.properties = migrationProperties("root", block.properties, oldBlock.data.settings);

        const fresh = JSON.parse(JSON.stringify(block.elements.gallery.items[0]));
        ["socialInfo", "bannerLabel"].forEach(function(v){
            fresh[v].properties.show = false;
            fresh[v].properties.showWeb = false;
        });

        block.elements.gallery.items = [];
        block.elements.gallery.properties.spanWeb = oldBlock.data.settings.size;
        oldBlock.data.data.forEach(function(v, i){
            const item = JSON.parse(JSON.stringify(fresh));

            item.banner.properties.src = v.data[0].src;

            
            item.subInfo.text = v.data[1].text;
            item.bannerInfo.text = v.data[2].text;
            item.heading.text = v.data[3].text;
            item.subDescription.text = v.data[4].text;
            item.primaryButton.text = v.data[5].text;

            item.primaryButton.properties = migrationProperties("button", item.primaryButton.properties, v.data[5]);

            item.properties.background ="#00000000";
            item.properties = migrationProperties("item", item.properties, v.settings, oldBlock.data.settings);

            ["banner", "subInfo", "bannerInfo", "heading", "subDescription", "primaryButton"].forEach(function(val, i){
                item[val].properties.show = true;
                item[val].properties.showWeb = true;
                item[val].properties = migrationProperties("item", item[val].properties, v.data[i].settings, oldBlock.data.settings);
            })
            
            
            
            // item.banner.properties = migrationProperties("item", item.banner.properties, v.data[1].settings, oldBlock.data.settings);
            // item.heading.properties = migrationProperties("item", item.heading.properties, v.data[0].settings, oldBlock.data.settings);

            block.elements.gallery.items.push(item);
        })

        //console.log(block);
        //console.log(oldBlock);
    }
    if(id === "65bb9b2f1109527e3853616c" && oldBlock.id === "card-list-wine") {
        
        block.elements.heading.text = oldBlock.data.elements[0].text;
        block.elements.description.text = oldBlock.data.elements[1].text;

        ["heading", "description"].forEach(function(v, i){
            block.elements[v].properties.show = true;
            block.elements[v].properties.showWeb = true;
            block.elements[v].properties = migrationProperties("item", block.elements[v].properties, oldBlock.data.elements[i].settings, oldBlock.data.settings);
        });

        ["primaryButton", "secondaryButton", "summary"].forEach(function(v){
            block.elements[v].properties.show = false;
            block.elements[v].properties.showWeb = false;
        })

      
       

        block.properties = migrationProperties("root", block.properties, oldBlock.data.settings);

        const fresh = JSON.parse(JSON.stringify(block.elements.gallery.items[0]));
        ["socialInfo", "bannerInfo"].forEach(function(v){
            fresh[v].properties.show = false;
            fresh[v].properties.showWeb = false;
        });
        
        ["summary", "description", "headingLabel"].forEach(function(v){
            fresh[v].properties.show = true;
            fresh[v].properties.showWeb = true;
        });

        block.elements.gallery.items = [];
        block.elements.gallery.properties.spanWeb = oldBlock.data.settings.size;
        oldBlock.data.data.forEach(function(v, i){
            const item = JSON.parse(JSON.stringify(fresh));

            item.bannerLabel.text = v.data[0].text;
            item.banner.properties.src = v.data[1].src;

            
            item.subInfo.text = v.data[2].text;
            item.headingLabel.text = v.data[3].text;
            
            item.heading.text = v.data[4].text;
            item.summary.text = v.data[5].text;
            item.description.text = v.data[6].text;
            
            item.subDescription.text = v.data[7].text;
            item.primaryButton.text = v.data[8].text;

            item.primaryButton.properties = migrationProperties("button", item.primaryButton.properties, v.data[8]);

            item.properties.background = "#FFFFFF";
            item.properties = migrationProperties("item", item.properties, v.settings, oldBlock.data.settings);

            ["bannerLabel", "banner", "subInfo", "headingLabel", "heading", "summary", "description", "subDescription", "primaryButton"].forEach(function(val, i){
                item[val].properties.show = true;
                item[val].properties.showWeb = true;
                item[val].properties = migrationProperties("item", item[val].properties, v.data[i].settings, oldBlock.data.settings);
            });
            
            block.elements.gallery.items.push(item);
        })

        // console.log(block);
        // console.log(oldBlock);
    }
    
    if(id === "654e3dc133cf1040fe0b4a7f" && oldBlock.id === "img-list-wine") {
        
        block.elements.heading.text = oldBlock.data.elements[0].text;
        block.elements.summary.text = oldBlock.data.elements[1].text;

        ["primaryButton", "secondaryButton"].forEach(function(v, i){
            block.elements[v].properties.show = false;
            block.elements[v].properties.showWeb = false;
        });
        

        ["heading", "summary"].forEach(function(v, i){
            block.elements[v].properties = migrationProperties("item", block.elements[v].properties, oldBlock.data.elements[i].settings, oldBlock.data.settings);
        });

        block.properties = migrationProperties("root", block.properties, oldBlock.data.settings);

        const fresh = JSON.parse(JSON.stringify(block.elements.gallery.items[0]));
        ["heading","summary", "bannerLabel", "icon", "socialInfo", "summary", "description", "subDescription", "footerHeading"].forEach(function(v){
            fresh[v].properties.show = false;
            fresh[v].properties.showWeb = false;
        });


        block.elements.gallery.items = [];
        block.elements.gallery.properties.spanWeb = oldBlock.data.settings.size;
        oldBlock.data.data.forEach(function(v, i){
            const item = JSON.parse(JSON.stringify(fresh));

            item.bannerLabel.text = v.data[0].text;
            item.banner.properties.src = v.data[1].src;
            
            ["bannerLabel", "banner"].forEach(function(val, i){
                item[val].properties = migrationProperties("item", item[val].properties, v.data[1].settings, oldBlock.data.settings);
            })
            block.elements.gallery.items.push(item);
        })

         //console.log(block);
        // console.log(oldBlock);
    }

    if(id === "65bcd8957403e631d635af43" && oldBlock.id === "contact-block-wine") {
        
        block.elements.headingLabel.text = "Get in touch with us";
        if(oldBlock.data.elements[0].text) {
            if(oldBlock.data.elements[0].text !== "") {
                block.elements.headingLabel.text = oldBlock.data.elements[0].text;
            }
        }
        
        
        block.elements.heading.text = oldBlock.data.elements[1].text;
        block.elements.summary.text = oldBlock.data.elements[2].text;
        
        block.elements.description.text = "<b>Location :</b> 4579 Kincheloe Road, Arapahoe North Carolina";
        if(oldBlock.data.elements[3].text) {
            if(oldBlock.data.elements[3].text !== "") {
                block.elements.description.text = oldBlock.data.elements[3].text;
            }
        }

        block.elements.subDescription.text = "<b>Phone :</b> 503-454-4021";
        if(oldBlock.data.elements[4].text) {
            if(oldBlock.data.elements[4].text !== "") {
                block.elements.subDescription.text = oldBlock.data.elements[4].text;
            }
        }

       
        
        block.elements.HoursTitle.text = oldBlock.data.elements[5].text;
        

        

        ["headingLabel", "heading", "description", "subDescription", "summary", "HoursTitle"].forEach(function(v, i){
            block.elements[v].properties.show = true;
            block.elements[v].properties.showWeb = true;
            block.elements[v].properties = migrationProperties("item", block.elements[v].properties, oldBlock.data.elements[i].settings, oldBlock.data.settings);
            
        });

        block.properties = migrationProperties("root", block.properties, oldBlock.data.settings);

        const fresh = JSON.parse(JSON.stringify(block.elements.gallery.items[0]));
        

        block.elements.gallery.items = [];
        // //block.elements.gallery.properties.spanWeb = oldBlock.data.settings.size;
        oldBlock.data.data.forEach(function(v, i){
            const item = JSON.parse(JSON.stringify(fresh));

            item.day.text = v.data[0].text;
            item.duration.text = v.data[1].text;
            
            ["day", "duration"].forEach(function(val, i){
                item[val].properties.show = true;
                item[val].properties.showWeb = true;
                item[val].properties = migrationProperties("item", item[val].properties, v.data[i].settings, oldBlock.data.settings);
                if(val === "duration") {
                    item[val].properties.textAlignment = "start"
                }
                if(val === "day") {
                    item[val].properties.textAlignment = "end"
                }
            });
            block.elements.gallery.items.push(item);
        })

        //console.log(block);
        // console.log(oldBlock);
    }
    if(id === "65bb5f672c119f4d147ede18" && oldBlock.id === "hero-slider-membership") {
        
        
        block.elements.heading.text = "TASTE OF GREAT FOOD";
        if(oldBlock.data.elements[0].text) {
            if(oldBlock.data.elements[0].text !== "") {
                block.elements.heading.text = oldBlock.data.elements[0].text;
            }
        }
        
        //block.elements.heading.text = "test me";
        block.elements.summary.text = oldBlock.data.elements[1].text;
        block.elements.description.text = oldBlock.data.elements[2].text;
        block.elements.primaryButton.text = oldBlock.data.elements[12].text;
        block.elements.secondaryButton.text = oldBlock.data.elements[13].text;

        block.elements.primaryButton.properties = migrationProperties("button", block.elements.primaryButton.properties, oldBlock.data.elements[12]);
        block.elements.secondaryButton.properties = migrationProperties("button", block.elements.secondaryButton.properties, oldBlock.data.elements[13]);


        const oldItems = [0, 1, 2, 12, 13];

        ["heading", "summary", "description", "primaryButton", "secondaryButton"].forEach(function(v, i){
            block.elements[v].properties.show = true;
            block.elements[v].properties.showWeb = true;
            block.elements[v].properties = migrationProperties("item", block.elements[v].properties, oldBlock.data.elements[oldItems[i]].settings, oldBlock.data.settings);
        });

        block.properties.overlayColor = oldBlock.data.elements[14].settings.backgroundColor;
        block.properties = migrationProperties("root", block.properties, oldBlock.data.settings);
        
        const fresh = JSON.parse(JSON.stringify(block.elements.gallery.items[0]));

        ["icon", "banner", "headingLabel", "heading", "summary", "description", "subDescription", "socialInfo", "userBanner", "userDescription", "primaryButton"].forEach(function(v){
            fresh[v].properties.show = false;
            fresh[v].properties.showWeb = false;
        });

        block.elements.gallery.items = [];
        block.elements.gallery.properties.spanWeb = 3;
        block.elements.gallery.properties.span = 1;

        [[3, 4, 5], [6, 7, 8], [9, 10, 11]].forEach(function(values, i){
            const item = JSON.parse(JSON.stringify(fresh));
            item["icon"].properties.iconCode = oldBlock.data.elements[values[0]].src;
            item["heading"].text = oldBlock.data.elements[values[1]].text;
            item["summary"].text = oldBlock.data.elements[values[2]].text;

            item.properties.background = "#00000000";
            item.properties.backgroundType = "color";

            ["icon", "heading", "summary"].forEach(function(val, i){
                item[val].properties.show = true;
                item[val].properties.showWeb = true;
                item[val].properties = migrationProperties("item", item[val].properties, oldBlock.data.elements[values[i]].settings, oldBlock.data.settings);
            })
            block.elements.gallery.items.push(item);
        });

        // console.log(block);
         //console.log(oldBlock);
    }
    if(id === "65bb9b2f1109527e3853616c" && oldBlock.id === "card-list-courses") {

        ["heading", "summary", "primaryButton", "secondaryButton", "description"].forEach(function(v){
            block.elements[v].properties.show = false;
            block.elements[v].properties.showWeb = false;
        });

        block.properties = migrationProperties("root", block.properties, oldBlock.data.settings);

        const fresh = JSON.parse(JSON.stringify(block.elements.gallery.items[0]));
        ["banner", "bannerInfo", "bannerLabel", "description", "heading", "icon", "socialInfo", "subDescription", "summary", "subInfo"].forEach(function(v){
            fresh[v].properties.show = false;
            fresh[v].properties.showWeb = false;
        });

        block.elements.gallery.items = [];
        block.elements.gallery.properties.spanWeb = oldBlock.data.settings.size;
        oldBlock.data.data.forEach(function(v, i){
            const item = JSON.parse(JSON.stringify(fresh));
            item.banner.properties.src = v.data[0].src;
            item.heading.text = v.data[1].text;
            item.summary.text = v.data[2].text;
            item.subDescription.text = v.data[3].text;
            item.primaryButton.text = v.data[4].text;

            item.primaryButton.properties = migrationProperties("button", item.primaryButton.properties, v.data[4]);

            item.properties.background = "#FFFFFF";
            item.properties = migrationProperties("item", item.properties, v.settings, oldBlock.data.settings);
            
            ["banner", "heading", "summary", "subDescription", "primaryButton"].forEach(function(val, i){
                item[val].properties.show = true;
                item[val].properties.showWeb = true;
                item[val].properties = migrationProperties("item", item[val].properties, v.data[i].settings, oldBlock.data.settings);
            })
            block.elements.gallery.items.push(item);
        })

        // console.log(block);
        // console.log(oldBlock);
    }
    if(id === "65bb5f672c119f4d147ede18" && oldBlock.id === "feature-list-course") {
        
        block.elements.heading.text = oldBlock.data.elements[0].text;
        block.elements.summary.text = oldBlock.data.elements[1].text;
        
        ["primaryButton", "secondaryButton", "description"].forEach(function(v){
            block.elements[v].properties.show = false;
            block.elements[v].properties.showWeb = false;
        });

        block.properties = migrationProperties("root", block.properties, oldBlock.data.settings);
        ["heading", "summary"].forEach(function(v, i){
            block.elements[v].properties.show = true;
            block.elements[v].properties.showWeb = true;
            block.elements[v].properties = migrationProperties("item", block.elements[v].properties, oldBlock.data.elements[i].settings, oldBlock.data.settings);
        });

        const fresh = JSON.parse(JSON.stringify(block.elements.gallery.items[0]));

        ["description", "subDescription", "userBanner", "socialInfo", "banner"].forEach(function(v){
            fresh[v].properties.show = false;
            fresh[v].properties.showWeb = false;
        });

        block.elements.gallery.items = [];
        oldBlock.data.data.forEach(function(v, i){
            const item = JSON.parse(JSON.stringify(fresh));

            item.icon.properties.iconCode = v.data[0].src;
            item.banner.properties.src = v.data[1].src;
            item.headingLabel.text = v.data[2].text;

            item.heading.text = "13 APRIL 2014";
            if(v.data[3].text) {
                if(v.data[3].text !== "") {
                    item.heading.text = v.data[3].text;
                }
            }
            
            
            item.summary.text = v.data[4].text;
            item.primaryButton.text = v.data[6].text;

            item.primaryButton.properties = migrationProperties("button", item.primaryButton.properties, v.data[6]);

            item.properties.background = "#FFFFFF";
            item.properties = migrationProperties("item", item.properties, v.settings, oldBlock.data.settings);

            ["icon", "banner", "headingLabel", "heading", "summary", "socialInfo", "primaryButton"].forEach(function(val, i){
                item[val].properties.show = true;
                item[val].properties.showWeb = true;
                item[val].properties = migrationProperties("item", item[val].properties, v.data[i].settings, oldBlock.data.settings);
            });

            block.elements.gallery.items.push(item);
        })


        // console.log(block);
        // console.log(oldBlock);
    }
    if(id === "65bb5f672c119f4d147ede18" && oldBlock.id === "feature-list-pricing") {
        
        block.elements.heading.text = oldBlock.data.elements[0].text;
        block.elements.summary.text = oldBlock.data.elements[1].text;
        
        ["primaryButton", "secondaryButton", "description"].forEach(function(v){
            block.elements[v].properties.show = false;
            block.elements[v].properties.showWeb = false;
        });

        block.properties = migrationProperties("root", block.properties, oldBlock.data.settings);
        ["heading", "summary"].forEach(function(v, i){
            block.elements[v].properties = migrationProperties("item", block.elements[v].properties, oldBlock.data.elements[i].settings, oldBlock.data.settings);
        });

        const fresh = JSON.parse(JSON.stringify(block.elements.gallery.items[0]));

        ["description", "subDescription", "userBanner", "socialInfo", "banner"].forEach(function(v){
            fresh[v].properties.show = false;
            fresh[v].properties.showWeb = false;
        });
        block.elements.gallery.items = [];
        oldBlock.data.data.forEach(function(v, i){
            const item = JSON.parse(JSON.stringify(fresh));

            item.icon.properties.src = v.data[0].src;
            item.banner.properties.src = v.data[1].src;
            item.headingLabel.text = v.data[2].text;
            item.heading.text = v.data[3].text;
            item.summary.text = v.data[4].text;
            item.primaryButton.text = v.data[6].text;

            item.primaryButton.properties = migrationProperties("button", item.primaryButton.properties, v.data[6]);

            item.properties.background = "#FFFFFF";
            item.properties = migrationProperties("item", item.properties, v.settings, oldBlock.data.settings);


            ["icon", "banner", "headingLabel", "heading", "summary", "socialInfo", "primaryButton"].forEach(function(val, i){
                item[val].properties.show = true;
                item[val].properties.showWeb = true;
                item[val].properties = migrationProperties("item", item[val].properties, v.data[i].settings, oldBlock.data.settings);
            });

           

            block.elements.gallery.items.push(item);
        })


        // console.log(block);
        // console.log(oldBlock);
    }
    if(id === "65b894faff49534e704e77cf" && oldBlock.id === "education-features") {
        
        block.elements.heading.text = oldBlock.data.elements[0].text;
        block.elements.banner.properties.src = oldBlock.data.elements[1].src;
        block.elements.description.text = oldBlock.data.elements[2].text;
        block.elements.primaryButton.text = oldBlock.data.elements[3].text;

        block.elements.primaryButton.properties = migrationProperties("button", block.elements.primaryButton.properties, oldBlock.data.elements[3]);

        
        ["secondaryButton", "summary", "primaryButton"].forEach(function(v){
            block.elements[v].properties.show = false;
            block.elements[v].properties.showWeb = false;
        });

        block.properties = migrationProperties("root", block.properties, oldBlock.data.settings);
        ["heading", "banner", "description", "primaryButton"].forEach(function(v, i){
            block.elements[v].properties.show = true;
            block.elements[v].properties.showWeb = true;
            block.elements[v].properties = migrationProperties("item", block.elements[v].properties, oldBlock.data.elements[i].settings, oldBlock.data.settings);
        });

        const fresh = JSON.parse(JSON.stringify(block.elements.gallery.items[0]));

        block.elements.gallery.items = [];
        oldBlock.data.data.forEach(function(v, i){
            const item = JSON.parse(JSON.stringify(fresh));

            item.icon.properties.src = v.data[0].src;
            if(v.data[1].text === "") {
                item.heading.text = "Responsive Framework";
            }
            else {
                item.heading.text = v.data[1].text;
            }
            

            

            ["icon", "heading"].forEach(function(val, i){
                item[val].properties.show = true;
                item[val].properties.showWeb = true;
                item[val].properties = migrationProperties("item", item[val].properties, v.data[i].settings, oldBlock.data.settings);
            });

            block.elements.gallery.items.push(item);
        })


        // console.log(block);
        // console.log(oldBlock);
    }

    if(id === "65abb88325350d4f9061d25e" && oldBlock.id === "about-courses") {

        ["heading", "summary", "description"].forEach(function(v){
            block.elements[v].properties.show = false;
            block.elements[v].properties.showWeb = false;
        });
        
       
        block.properties = migrationProperties("root", block.properties, oldBlock.data.settings);

        const fresh = JSON.parse(JSON.stringify(block.elements.swiper.items[0]));
        // ["bannerLabel", "banner", "socialInfo", "subDescription", "footerHeading"].forEach(function(v){
        //     fresh[v].properties.show = false;
        // });

       

        fresh.headingLabel.text = oldBlock.data.elements[0].text;
        fresh.heading.text = oldBlock.data.elements[1].text;
        fresh.summary.text = oldBlock.data.elements[2].text;
        fresh.primaryButton.text = oldBlock.data.elements[3].text;
        fresh.googleplay.properties.src = oldBlock.data.elements[4].src.replace("__CDN__PATH__", "https://d2wuvg8krwnvon.cloudfront.net/");;
        fresh.banner.properties.src = oldBlock.data.elements[5].src;
        
        
        

        ["headingLabel", "heading", "summary", "primaryButton", "googleplay", "banner"].forEach(function(v, i){
            fresh[v].properties.show = true;
            fresh[v].properties.showWeb = true;
            fresh[v].properties = migrationProperties("item", fresh[v].properties, oldBlock.data.elements[i].settings, oldBlock.data.settings);
        });

        ["secondaryButton", "appstore"].forEach(function(v){
            fresh[v].properties.show = false;
            fresh[v].properties.showWeb = false;
        });

        
        

        block.elements.swiper.properties.span = 1;
        block.elements.swiper.properties.spanWeb = 1;
        block.elements.swiper.items = [fresh];
        
        

        // console.log(block);
        // console.log(oldBlock);
    }

    if(id === "65bb9b2f1109527e3853616c" && oldBlock.id === "course-testimonial") {

        block.elements.heading.text = oldBlock.data.elements[0].text;
        block.elements.summary.properties.src = oldBlock.data.elements[1].text;

        ["primaryButton", "secondaryButton", "description"].forEach(function(v){
            block.elements[v].properties.show = false;
            block.elements[v].properties.showWeb = false;
        });

        ["heading", "summary"].forEach(function(v, i){
            block.elements[v].properties.show = true;
            block.elements[v].properties.showWeb = true;
            block.elements[v].properties = migrationProperties("item", block.elements[v].properties, oldBlock.data.elements[i].settings, oldBlock.data.settings);
        });

        
        block.properties.overlayColor = "#db805cf4";
        block.properties = migrationProperties("root", block.properties, oldBlock.data.settings);

        const fresh = JSON.parse(JSON.stringify(block.elements.gallery.items[0]));
        ["banner", "bannerInfo", "bannerLabel", "description", "heading", "icon", "socialInfo", "subDescription", "summary", "subInfo", "primaryButton"].forEach(function(v){
            fresh[v].properties.show = false;
            fresh[v].properties.showWeb = false;
        });

        block.elements.gallery.items = [];
        block.elements.gallery.properties.spanWeb = 1;
        block.elements.gallery.properties.span = 1;
        oldBlock.data.data.forEach(function(v, i){
            const item = JSON.parse(JSON.stringify(fresh));
            item.icon.properties.iconCode = v.data[0].src;
            item.heading.text = v.data[1].text;
            item.subDescription.text = "ANDREA MICHELON";
            
            if(v.data[2].text) {
                if(v.data[2].text !== "") {
                   item.subDescription.text = v.data[2].text;
                }
            }

            item.icon.properties.iconSizeWeb = "100";
            item.icon.properties.iconSize = "100";
            item.icon.properties.padding = "0,0,0,0";
            item.icon.properties.paddingWeb = "0,0,0,0";
            
            
            item.properties.borderSize = 0;
            item.properties.background = "#00000000";
            item.properties = migrationProperties("item", item.properties, v.settings, oldBlock.data.settings);
            
            ["icon", "heading", "subDescription"].forEach(function(val, i){
                item[val].properties.show = true;
                item[val].properties.showWeb = true;
                item[val].properties = migrationProperties("item", item[val].properties, v.data[i].settings, oldBlock.data.settings);
            });
            block.elements.gallery.items.push(item);
        });
        
        // console.log(block);
        // console.log(oldBlock);
    }

    if(id === "65bb9b2f1109527e3853616c" && oldBlock.id === "hero-slider-restaurants") {
        
        block.elements.heading.text = oldBlock.data.elements[0].text;

        ["primaryButton", "secondaryButton", "description", "summary", "heading"].forEach(function(v){
            block.elements[v].properties.show = false;
            block.elements[v].properties.showWeb = false;
        });

        // ["heading"].forEach(function(v, i){
        //     block.elements[v].properties.show = true;
        //     block.elements[v].properties.showWeb = true;
        //     block.elements[v].properties = migrationProperties("item", block.elements[v].properties, oldBlock.data.elements[i].settings, oldBlock.data.settings);
        // });

        
        block.properties = migrationProperties("root", block.properties, oldBlock.data.settings);

        const fresh = JSON.parse(JSON.stringify(block.elements.gallery.items[0]));
        ["banner", "bannerInfo", "bannerLabel", "description", "heading", "icon", "socialInfo", "subDescription", "summary", "subInfo", "primaryButton"].forEach(function(v){
            fresh[v].properties.show = false;
            fresh[v].properties.showWeb = false;
        });

        block.elements.gallery.items = [];
        block.elements.gallery.properties.spanWeb = 1;
        block.elements.gallery.properties.span = 1;
        oldBlock.data.data.forEach(function(v, i){
            const item = JSON.parse(JSON.stringify(fresh));
            item.heading.text = v.data[0].text;
            item.subDescription.text = v.data[1].text;
            item.primaryButton.text = v.data[2].text;
            item.secondaryButton.text = v.data[3].text;
            item.banner.properties.src = v.data[4].src;

            item.primaryButton.properties = migrationProperties("button", item.primaryButton.properties, v.data[2]);
            item.secondaryButton.properties = migrationProperties("button", item.secondaryButton.properties, v.data[3]);
            
            item.properties.borderSize = 0;
            item.properties.background = "#00000000";
            item.properties = migrationProperties("item", item.properties, v.settings, oldBlock.data.settings);
            
            ["heading", "subDescription", "primaryButton", "secondaryButton", "banner"].forEach(function(val, i){
                item[val].properties.show = true;
                item[val].properties.showWeb = true;
                item[val].properties = migrationProperties("item", item[val].properties, v.data[i].settings, oldBlock.data.settings);
            });
            block.elements.gallery.items.push(item);
        });

        // console.log(block);
        // console.log(oldBlock);
    }

    

    

    
    
    
    return block;
}

const fetchMigration = async function(appId) {
    const response = await fetchAi({
        "method":"getAllBlocks","lang":"en"
    });
    if(appId) {
        const pageResponse = await fetchJson2(appId);
        return {
            blocks:response.data,
            pageJson:pageResponse
        }
        
    }
    else {
        const pageResponse = await fetchJson({
            method:"getActivePage",
            appId:"eb9a8833aa18"
        });
        return {
            blocks:response.data,
            pageJson:pageResponse.activePage[0].pageJson
        }
    }
}

export default function Migration(props) {
    const [status, setStatus] = useState(false); 
    const [data, setData] = useState(null); 
    useEffect(() => {

        fetchMigration(props.category).then(function(response){
            const blocks = response.blocks;
            const pageJson = response.pageJson;
            const connectedBlocks = pageJson.filter(function(v){
                if(connected[v.id]) {
                    return true;
                }
                return false;
            })
            const allData = connectedBlocks.map(function(v){
                return migrationBlock(blocks.filter(function(e){
                    if(e.id === connected[v.id]) {
                        return true;
                    }
                    return false;
                })[0], v)
            })
            setData(allData);
        });
    }, []);

    if(data) {
        return <Preview data={{
            dynamicAIData:data
        }} mode={"live"} device={"desktop"} />
    }

    return <div>Migration</div>
}